import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import MeusAgendamentos from './pages/MeusAgendamentos';
import CalendarioAgendamentos from './components/CalendarioAgendamentos';
import PrivateRoute from './routes/PrivateRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/agendamentos" element={<MeusAgendamentos />} />
        <Route path="/calendario" element={<CalendarioAgendamentos />} />
        <Route
          path="/agendamentos"
          element={
            <PrivateRoute>
              <MeusAgendamentos />
            </PrivateRoute>
          }
        />
        <Route
          path="/calendario"
          element={
            <PrivateRoute>
              <CalendarioAgendamentos />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;